import { ComponentType, forwardRef, Ref, useMemo, useState } from "react"
import { TextInput } from "react-native"

import { useAppTheme } from "src/hooks/useAppTheme"
import { Icon } from "./Icon"
import { TextField, TextFieldAccessoryProps, TextFieldProps } from "./TextField"

export const PasswordTextField = forwardRef(function PasswordTextField(
  props: TextFieldProps,
  ref: Ref<TextInput>,
) {
  const { theme } = useAppTheme()
  const [showPassword, setShowPassword] = useState(false)

  // Explicitly destructure autofill-related props so they are never accidentally
  // overridden by the {...restProps} spread below.
  const { value, autoComplete, textContentType, ...restProps } = props

  const PasswordRightAccessory: ComponentType<TextFieldAccessoryProps> = useMemo(
    () =>
      function PasswordRightAccessory(accessoryProps: TextFieldAccessoryProps) {
        return (
          <Icon
            icon={showPassword ? "view" : "hidden"}
            color={
              !accessoryProps.editable || !value ? theme.colors.textDim : theme.colors.inputText
            }
            containerStyle={accessoryProps.style}
            size={20}
            onPress={() => setShowPassword(!showPassword)}
            style={accessoryProps.style}
          />
        )
      },
    [showPassword, value, theme.colors.inputText, theme.colors.textDim],
  )

  return (
    <TextField
      {...restProps}
      value={value}
      ref={ref}
      autoCapitalize="none"
      autoComplete={autoComplete ?? "password"}
      textContentType={textContentType}
      autoCorrect={false}
      secureTextEntry={!showPassword}
      RightAccessory={PasswordRightAccessory}
    />
  )
})
